export function enumToText(enumType: any, value: number): string {
  if (enumType === undefined || isNaN(value) || value < 0 || value >= Object.keys(enumType).length / 2) {
    return '';
  }

  const enumKey = Object.values(enumType)[value];

  return enumKey?.toString().replace(/([a-z])([A-Z])/g, '$1 $2');
}
